import { render, staticRenderFns } from "./FormDescricaoMotivo.vue?vue&type=template&id=7d5fec95&scoped=true"
import script from "./FormDescricaoMotivo.vue?vue&type=script&lang=js"
export * from "./FormDescricaoMotivo.vue?vue&type=script&lang=js"
import style0 from "./FormDescricaoMotivo.vue?vue&type=style&index=0&id=7d5fec95&prod&lang=scss"
import style1 from "./FormDescricaoMotivo.vue?vue&type=style&index=1&id=7d5fec95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5fec95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VForm,VIcon,VTextarea})
